import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

const PlantDetailsConfig = { auth: [...authRoles.admin, ...authRoles.processor], routes: [{ path: '/plant-management/:id?', component: FuseLoadable({ loader: () => import('./plant-details/PlantDetails') }) }] };

export default PlantDetailsConfig;
